export const billTypeList = [
  { label: 'CDEC', value: 'CDEC' },
  // Purchase-order payments pushed by ZoProcure (config/constants.js bill_type carries the same value)
  { label: 'Procurement (ZoProcure)', value: 'Procurement' },
  { label: 'Activation', value: 'Activation' },
  { label: 'Food', value: 'Food' },
  { label: 'P2P - Tickets', value: 'P2P' },
  { label: 'Marketing Expenses', value: 'ME' },
  { label: 'Warehouse', value: 'warehouse' },
  { label: 'Legal', value: 'legal' },
  { label: 'Corporate-Tax', value: 'Corporate-Tax' },
  { label: 'Corporate-Finance (Controllership, Strategy & FP&A)', value: 'Corporate-Finance' },
  { label: 'Corporate-Litigation', value: 'Corporate-Litigation' },
  { label: 'Corporate-Secretarial', value: 'Corporate-Secretarial' },
  { label: 'Corporate-Legal', value: 'Corporate-Legal' },
  { label: 'Corporate-IT', value: 'Corporate-IT' },
  { label: 'Corporate-Admin', value: 'Corporate-Admin' },
  { label: 'Corporate-Tech', value: 'Corporate-Tech' },
  { label: 'Corporate-Marketing', value: 'Corporate-Marketing' },
  { label: 'Corporate-HR - Operations', value: 'Corporate-HROperations' },
  { label: 'Corporate-HR - Talent Acquistion', value: 'Corporate-HRTalentAcquistion' },
  { label: 'Corporate-CE', value: 'Corporate-CE' },
  { label: 'Corporate-CE - Property Brokerage', value: 'Corporate-CEPropertyBrokerage' },
  { label: 'Corporate-SH - Brokerage', value: 'Corporate-SHBrokerage' },
  { label: 'Corporate-SH - SPRA', value: 'Corporate-SH-SPRA' },
  { label: 'Corporate-Supply Chain', value: 'Corporate-SupplyChain' },
  { label: 'Corporate-SH - Client Gifting', value: 'Corporate-SHClientGifting' },
  { label: 'Corporate-Zeassetz', value: 'Corporate-Zeassetz' },
  { label: 'Corporate-PR', value: 'Corporate-PR' },
  { label: 'Corporate-Legal - Estamps', value: 'Corporate-LegalEstamps' },
  { label: 'Corporate-ZVacations - Brokerage', value: 'Corporate-ZVacationsBrokerage' },
  { label: 'Corporate-SH', value: 'Corporate-SH' },
  { label: 'Corporate', value: 'Corporate' }
];


// WEBPACK FOOTER //
// ./src/constants/billTypeList.js